import { Group } from '@/router/group.model';
import { myAccount, changePassword } from '@/router/routes';

const routes = [myAccount, changePassword];

const authMenuGroup = new Group('Auth', 'auth-menu', routes, {
  superRoot: false,
  hidden: true
});

export { authMenuGroup };
export default authMenuGroup;
